import clsx from "clsx";
import { motion } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

interface AnimateChangeInHeightProps {
	children: React.ReactNode;
	className?: string;
}

export const AnimateChangeInHeight: React.FC<AnimateChangeInHeightProps> = ({
	children,
	className,
}) => {
	const [height, setHeight] = useState<number>(0);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!containerRef.current) return;

		const ro = new ResizeObserver((entries) => {
			window.requestAnimationFrame(() => {
				if (entries[0]) {
					setHeight(entries[0].contentRect.height);
				}
			});
		});

		ro.observe(containerRef.current);
		return () => ro.disconnect();
	}, []);

	return (
		<motion.div
			className={clsx(className ?? "", "jFcalc-overflow-hidden")}
			style={{ height: "auto" }}
			transition={{ duration: 0.2 }}
		>
			<div ref={containerRef}>{children}</div>
		</motion.div>
	);
};
